/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface LevelDto {
  lvl: number;
  /**
   * Formula: \"1 = 0.1BPS = 0.001% = 0.00001\".
   */
  spread: number;
}
